module.exports = __webpack_public_path__ + "img/7.41b7afa3.jpg";